import dataLayerPush, {
  DataLayerListenerArgs,
} from "@magalu/ecomm-components/rave/events/GA/utils/dataLayerPush";

import { VIEW_CONTENT } from "@utils/constants/events-type";

type ViewContentProps = {
  eventId?: string;
  globalData: DataLayerListenerArgs<unknown>;
  value: {
    content_id?: string;
    content_type?: string;
    screenName?: string;
  };
};

export const viewContent = ({ globalData, value }: ViewContentProps) => {
  return dataLayerPush(() => ({
    content_id: value?.content_id || undefined,
    content_type: value?.content_type || undefined,
    event: VIEW_CONTENT,
    screenName: globalData?.route?.name || undefined,
  }))({ globalData });
};
